import { BASEURL, Request, TRequestMethod } from "./request.ts";
import { Schema } from "./validation.ts";

/*
Der Webservice fdw_session gibt eine für diese Anfrage eindeutige ID zurück, 
welche für die weiteren Webservices zu der jeweiligen Anfrage mitgegeben werden muss.
*/

export type FDWDoiCheckStatusResponse = boolean;

export class FDWDoiCheckStatus extends Request<FDWDoiCheckStatusResponse>{
    method : TRequestMethod = "GET";
	responseSchema : Schema = 'boolean';

    constructor (
        public session_id: string,
        public token: string){
        super();
    }

    route() : string{
        return `${BASEURL}/fdw_doi_checkstatus/${this.session_id}/${this.token}`;
    }
}